import {
  Wifi,
  Car,
  Waves,
  Tv,
  Dumbbell,
  Snowflake,
  Flame,
  WashingMachine,
  Dog,
  Mountain,
  TreePine,
  Coffee,
  SprayCan,
  Sofa,
  CircleParking,
  Refrigerator,
  Microwave,
  Shirt,
  Sun,
  Lock,
  Bell,
  LifeBuoy,
  ConciergeBell,
  ShieldCheck,
  Droplets,
  CookingPot,
  MonitorPlay,
  Fence,
  Building2,
  Sailboat,
  Flower2,
  BedDouble,
  Wind,
  Bath,
  Heater,
  AirVent,
  Cctv,
  DoorOpen,
  Vault,
  UtensilsCrossed,
  Armchair,
  Wine,
  ParkingCircle,
  type LucideIcon,
} from "lucide-react";

// Mapeamento de ícones específicos e elegantes para cada comodidade
export const amenityIcons: Record<string, LucideIcon> = {
  // Conectividade
  wifi: Wifi,
  
  // Transporte & Estacionamento
  parking: ParkingCircle,
  garagem: CircleParking,
  estacionamento: Car,
  
  // Piscina & Água
  pool: Waves,
  piscina: Waves,
  jacuzzi: Droplets,
  spa: Bath,
  
  // Climatização
  ac: Snowflake,
  ar_condicionado: Snowflake,
  aquecimento: Heater,
  heating: Heater,
  ventilador: Wind,
  ar_condicionado_central: AirVent,
  
  // Entretenimento
  tv: MonitorPlay,
  televisao: MonitorPlay,
  
  // Cozinha & Alimentação
  kitchen: CookingPot,
  cozinha: CookingPot,
  cozinha_completa: UtensilsCrossed,
  frigobar: Refrigerator,
  frigorifico: Refrigerator,
  microondas: Microwave,
  cafe_manha: Coffee,
  cafeteira: Coffee,
  restaurante: UtensilsCrossed,
  bar: Wine,
  
  // Fitness & Lazer
  gym: Dumbbell,
  ginasio: Dumbbell,
  academia: Dumbbell,
  
  // Lavandaria
  maquina_lavar: WashingMachine,
  washer: WashingMachine,
  ferro_passar: Shirt,
  lavandaria: WashingMachine,
  
  // Animais
  pets: Dog,
  pets_allowed: Dog,
  aceita_pets: Dog,
  
  // Vistas
  vista_mar: Sailboat,
  vista_montanha: Mountain,
  vista_cidade: Building2,
  vista_panoramica: Mountain,
  panoramic_view: Mountain,
  
  // Espaços Externos
  jardim: Flower2,
  terraco: Fence,
  varanda: Fence,
  churrasqueira: Flame,
  solarium: Sun,
  area_externa: TreePine,
  
  // Quartos & Conforto
  sala_estar: Armchair,
  quarto_luxo: BedDouble,
  roupa_cama: BedDouble,
  sofa: Sofa,
  
  // Limpeza & Serviços
  limpeza: SprayCan,
  limpeza_diaria: SprayCan,
  concierge: ConciergeBell,
  servico_quarto: DoorOpen,
  
  // Segurança
  seguranca: ShieldCheck,
  security: ShieldCheck,
  seguranca_24h: ShieldCheck,
  cofre: Vault,
  camera_seguranca: Cctv,
  porteiro: Bell,
  alarme: Bell,
  
  // Praia & Mar
  salva_vidas: LifeBuoy,
  praia: Sailboat,
  
  // Outros
  closet: Shirt,
  roupeiro: Shirt,
  view: Mountain,
  fridge: Refrigerator,
  coffee: Coffee,
  microwave: Microwave,
};

// Labels em português para cada comodidade
export const amenityLabels: Record<string, string> = {
  wifi: "Wi-Fi",
  parking: "Garagem",
  garagem: "Garagem",
  estacionamento: "Garagem",
  pool: "Piscina",
  piscina: "Piscina",
  jacuzzi: "Jacuzzi",
  spa: "Spa",
  ac: "Ar Condicionado",
  ar_condicionado: "Ar Condicionado",
  aquecimento: "Aquecimento",
  heating: "Aquecimento",
  ventilador: "Ventilador",
  ar_condicionado_central: "AC Central",
  tv: "Smart TV",
  televisao: "Televisão",
  kitchen: "Cozinha",
  cozinha: "Cozinha",
  cozinha_completa: "Cozinha Completa",
  frigobar: "Frigobar",
  frigorifico: "Frigorífico",
  microondas: "Microondas",
  cafe_manha: "Café da Manhã",
  cafeteira: "Cafeteira",
  restaurante: "Restaurante",
  bar: "Bar",
  gym: "Ginásio",
  ginasio: "Ginásio",
  academia: "Academia",
  maquina_lavar: "Máq. Lavar",
  washer: "Máq. Lavar",
  ferro_passar: "Ferro de Passar",
  lavandaria: "Lavandaria",
  pets: "Aceita Pets",
  pets_allowed: "Aceita Pets",
  aceita_pets: "Aceita Pets",
  vista_mar: "Vista Mar",
  vista_montanha: "Vista Montanha",
  vista_cidade: "Vista Cidade",
  vista_panoramica: "Vista Panorâmica",
  panoramic_view: "Vista Panorâmica",
  jardim: "Jardim",
  terraco: "Terraço",
  varanda: "Varanda",
  churrasqueira: "Churrasqueira",
  solarium: "Solarium",
  area_externa: "Área Externa",
  sala_estar: "Sala de Estar",
  quarto_luxo: "Quarto Luxo",
  roupa_cama: "Roupa de Cama",
  sofa: "Sofá",
  limpeza: "Limpeza",
  limpeza_diaria: "Limpeza Diária",
  concierge: "Concierge",
  servico_quarto: "Serviço Quarto",
  seguranca: "Segurança",
  security: "Segurança 24h",
  seguranca_24h: "Segurança 24h",
  cofre: "Cofre",
  camera_seguranca: "Câmera CCTV",
  porteiro: "Porteiro",
  alarme: "Alarme",
  salva_vidas: "Salva-vidas",
  praia: "Praia",
  closet: "Closet",
  roupeiro: "Roupeiro",
  view: "Vista Panorâmica",
  fridge: "Frigorífico",
  coffee: "Cafeteira",
  microwave: "Microondas",
};

// Lista de comodidades para formulários (AddProperty e PropertyFilters)
export const FORM_AMENITIES = [
  { id: "wifi", label: "Wi-Fi", icon: Wifi },
  { id: "parking", label: "Garagem", icon: ParkingCircle },
  { id: "pool", label: "Piscina", icon: Waves },
  { id: "ac", label: "Ar Condicionado", icon: Snowflake },
  { id: "tv", label: "Smart TV", icon: MonitorPlay },
  { id: "kitchen", label: "Cozinha", icon: CookingPot },
  { id: "gym", label: "Ginásio", icon: Dumbbell },
  { id: "security", label: "Segurança 24h", icon: ShieldCheck },
  { id: "heating", label: "Aquecimento", icon: Heater },
  { id: "washer", label: "Máq. Lavar", icon: WashingMachine },
  { id: "coffee", label: "Cafeteira", icon: Coffee },
  { id: "fridge", label: "Frigorífico", icon: Refrigerator },
  { id: "microwave", label: "Microondas", icon: Microwave },
  { id: "pets", label: "Aceita Pets", icon: Dog },
  { id: "view", label: "Vista Panorâmica", icon: Mountain },
  { id: "closet", label: "Roupeiro", icon: Shirt },
] as const;

// Lista de comodidades para filtros (versão reduzida)
export const FILTER_AMENITIES = [
  { id: "wifi", label: "Wi-Fi", icon: Wifi },
  { id: "parking", label: "Garagem", icon: ParkingCircle },
  { id: "ac", label: "Ar Condicionado", icon: Snowflake },
  { id: "kitchen", label: "Cozinha", icon: CookingPot },
  { id: "tv", label: "Smart TV", icon: MonitorPlay },
  { id: "pool", label: "Piscina", icon: Waves },
  { id: "security", label: "Segurança 24h", icon: ShieldCheck },
] as const;

// Helper para obter ícone com fallback
export const getAmenityIcon = (amenityKey: string): LucideIcon => {
  return amenityIcons[amenityKey.toLowerCase()] || SprayCan;
};

// Helper para obter label com fallback
export const getAmenityLabel = (amenityKey: string): string => {
  const key = amenityKey.toLowerCase();
  return amenityLabels[key] || amenityKey.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
};
